export default __webpack_public_path__ + "images/bgflt6.f94d4bd.jpg";